<!-- search -->
<template>
  <div class="container">
    <div class="handle-box">
      <el-form>
        <el-row :gutter="10">
          <span
            class="gray"
            style="
              margin-left: 5px;
              background: #ffffff;
              width: 110px;
              text-align: left;
              display: inline-block;
              font-size: 14px;
            "
            >单位名称:</span
          >
          <el-input
            placeholder="单位名称"
            v-model="productTagQuery.productName"
            class="handle-input mr10"
            style="width: 12%"
            size="mini"
          ></el-input>
          <span
            class="gray"
            style="
              margin-left: 5%;
              background: #ffffff;
              width: 110px;
              text-align: left;
              display: inline-block;
              font-size: 14px;
            "
            >单品编码:</span
          >
          <el-input
            placeholder="单品编码"
            v-model="productTagQuery.productCode"
            class="handle-input mr10"
            style="width: 12%"
            size="mini"
          ></el-input>
        </el-row>
        <el-row :gutter="10">
          <span
            class="gray"
            style="
              margin-left: 5px;
              background: #ffffff;
              width: 110px;
              text-align: left;
              display: inline-block;
              font-size: 14px;
            "
            >所属分类:</span
          >
          <el-input
            placeholder="所属分类"
            v-model="productTagQuery.productName"
            class="handle-input mr10"
            style="width: 12%"
            size="mini"
          ></el-input>
          <span
            class="gray"
            style="
              margin-left: 5%;
              background: #ffffff;
              width: 110px;
              text-align: left;
              display: inline-block;
              font-size: 14px;
            "
            >上架状态:</span
          >
          <el-select
            v-model="productTagQuery.isControlSales"
            filterable
            placeholder="请选择"
            style="width: 12%; margin-right: 5px"
            size="mini"
          >
            <el-option
              v-for="item in isOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            style="margin-left: 5%"
            icon="el-icon-search"
            @click="handleSearchButton"
            size="mini"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-lx-refresh"
            @click="emptySearch"
            size="mini"
            >重置</el-button
          >
        </el-row>
        <el-row :gutter="10"></el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
           productTagQuery: {
        productName: null,
        productCode: null,
        pageSize: 10,
        pageStart: 1,
      },
            isOption: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
    };
  },

  components: {},

  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
  margin-bottom: 10px;
}
</style>